import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import compileErrors from "../compileErorrs"
import { serviceCallSendDataArray } from "../serviceCall"
import { setLoading } from "../../feature/authSlice"

export const approvePropApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCallSendDataArray({
      url: apiConstants.Property.APPROVE_PROP,
      method: 'post',
      data: data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
